import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import { HelmetProvider } from "react-helmet-async";
import custom_theme from "./Utils/CustomTheme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ConfigProvider theme={custom_theme}>
    {/* <React.StrictMode> */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
    {/* </React.StrictMode> */}
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
